<div class="backDrop center white" *ngIf="visible$ | async">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-center">Create warning modal message</h4>
            </div>
            <div class="modal-body padding-modal">
                <form [formGroup]="form" class="form-vertical row"  data-cy="create-contract-form">
                    <div class="form-group col-md-6">
                        <label>Name</label>
                        <dx-text-box as-validator class="form-control" valueChangeEvent="keyup" formControlName="name" name="name"></dx-text-box>
                    </div>
                    <div class="form-group col-md-6 context-formgroup">
                        <label>Context</label>
                        <div class="context-lookup-container">
                            <dx-lookup as-validator class="form-control" valueExpr="id" displayExpr="description" [showClearButton]="false"
                                [dataSource]="contexts" formControlName="context" name="context">
                            </dx-lookup>
                            <button class="btn btn-primary" (click)="viewTranslations()">View Translations</button>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label>From Link Template</label>
                        <multiselect-dropdown [dataSource]="selectableFromLinkTemplates"></multiselect-dropdown>
                    </div>
                    <div class="form-group col-md-6">
                        <label>To Link Template</label>
                        <multiselect-dropdown [dataSource]="selectableToLinkTemplates"></multiselect-dropdown>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Start Date</label>
                        <dx-date-box as-validator [showClearButton]="true" formControlName="startDate" name="startDate"></dx-date-box>
                    </div>
                    <div class="form-group col-md-6">
                        <label>End Date</label>
                        <dx-date-box as-validator [showClearButton]="true" formControlName="endDate" name="endDate"></dx-date-box>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Height</label>
                        <dx-text-box as-validator class="form-control" valueChangeEvent="keyup" formControlName="height" name="height"></dx-text-box>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Width</label>
                        <dx-text-box as-validator class="form-control" valueChangeEvent="keyup" formControlName="width" name="width"></dx-text-box>
                    </div>
                    <div class="form-group col-md-12">
                        <label>Message HTML</label>
                        <dx-text-area as-validator class="form-control" valueChangeEvent="keyup" formControlName="messageHtml" name="messageHtml"></dx-text-area>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary bottom-margin" (click)="ok()">Save</button>
                <button class="btn btn-default bottom-margin" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<json-editor-modal></json-editor-modal>
